import { ConsoleApiError } from './consoleApi';

/** What moderation's POST /auto-review/batch answers (auto_review.run_batch_review). */
export type AutoReviewResult =
  | { status: 'complete'; total: number; approved: number; rejected: number; errors: number }
  | { status: 'skipped'; reason: string };

const STILL_RUNNING = 'Refresh the queue in a few minutes to see its results.';

function documents(n: number): string {
  return `${n} document${n === 1 ? '' : 's'}`;
}

/** The alert after a run: how many documents it reviewed, and what became of them. */
export function describeAutoReview(r: Record<string, unknown>): string {
  if (r.status === 'skipped' && r.reason === 'batch_in_progress') {
    return `Auto-review is already running. ${STILL_RUNNING}`;
  }
  const { status, total, approved, rejected, errors } = r as Partial<Record<string, unknown>>;
  if (status !== 'complete' || ![total, approved, rejected, errors].every((n) => typeof n === 'number')) {
    return `Auto-review returned an unexpected answer:\n${JSON.stringify(r, null, 2).slice(0, 400)}`;
  }
  const done = r as Extract<AutoReviewResult, { status: 'complete' }>;
  if (done.total === 0) return 'Auto-review found no pending documents.';
  const lines = [`Auto-review reviewed ${documents(done.total)}: ${done.approved} approved, ${done.rejected} rejected.`];
  if (done.errors > 0) lines.push(`${documents(done.errors)} could not be reviewed and stay in the queue.`);
  return lines.join('\n');
}

/** A 504 is core's relay giving up while moderation's batch carries on, not a failure. */
export function describeAutoReviewError(e: unknown): string {
  if (e instanceof ConsoleApiError && e.status === 504) {
    return `Auto-review is still running on the server. ${STILL_RUNNING}`;
  }
  return e instanceof Error ? e.message : 'Auto-review failed';
}
